import React from 'react'
import { isEmpty } from 'lodash'

export default ({ isShow, onHide, jobAssignment, onSubmit }) => {
  if ([jobAssignment].some(isEmpty)) return null
  if (!isShow) return null

  const { staff, service } = jobAssignment

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onHide} />
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">
            ACCEPT JOB CONFIRM
          </h2>
          <button
            onClick={onHide}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-6">
          <div className="text-xl text-gray-800">
            Is{' '}
            <strong>
              "
              <u>
                {staff.firstName} {staff.lastName}
              </u>
              "
            </strong>{' '}
            intentionally to accept job assignment of{' '}
            <strong>
              "<u>{service.displayName}</u>"
            </strong>{' '}
            ?
          </div>
        </div>
        <div className="flex items-center justify-end p-6 border-t border-gray-200 gap-3">
          <button
            onClick={onHide}
            className="px-6 py-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="px-6 py-3 text-base font-medium text-white bg-primary hover:bg-primary-dark rounded-lg transition-colors"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  )
}
